import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UserMenu } from './UserMenu';
import { NotificationsBadge } from './NotificationsBadge';
import { NavIcon } from './SidebarNavItem';
import { useTheme } from '@/providers/ThemeProvider';
import { useMe } from '@/features/auth/hooks/useMe';
import { Link } from '@tanstack/react-router';
import { ROUTES } from '@/lib/constants';
import { UserRole } from '@academia-apolo/shared-types';
function getNotificationsRoute(role) {
    // Each role has its own notifications route: the professor's used to point
    // at /director/notificaciones, which the director-only guard bounced back
    // to /profesor/inicio (professor could never open notifications).
    if (role === UserRole.DIRECTOR)
        return ROUTES.DIRECTOR_NOTIFICATIONS;
    if (role === UserRole.PROFESSOR)
        return ROUTES.PROFESSOR_NOTIFICATIONS;
    return ROUTES.STUDENT_NOTIFICATIONS;
}
function iconButtonStyle() {
    return { color: 'var(--fg-2)' };
}
function onIconHover(e) {
    e.currentTarget.style.background = 'var(--hover)';
}
function onIconLeave(e) {
    e.currentTarget.style.background = 'transparent';
}
export function Header({ onMenuClick }) {
    const { theme, toggleTheme } = useTheme();
    const { data: user } = useMe();
    return (_jsxs("header", { className: "flex h-14 items-center gap-2 px-3 sm:gap-3 sm:px-4 md:px-6", style: {
            background: 'var(--surface)',
            borderBottom: '1px solid var(--border)',
        }, children: [_jsx("button", { type: "button", onClick: onMenuClick, className: "rounded-lg p-2 transition-colors md:hidden", style: iconButtonStyle(), onMouseEnter: onIconHover, onMouseLeave: onIconLeave, "aria-label": "Abrir men\u00FA", children: _jsx(NavIcon, { name: "menu", className: "h-5 w-5" }) }), _jsx("div", { className: "flex-1" }), _jsxs(Link, { to: getNotificationsRoute(user?.role), className: "relative rounded-lg p-2 transition-colors", style: iconButtonStyle(), onMouseEnter: onIconHover, onMouseLeave: onIconLeave, "aria-label": "Notificaciones", children: [_jsx(NavIcon, { name: "bell", className: "h-5 w-5" }), _jsx("span", { className: "absolute -right-0.5 -top-0.5", children: _jsx(NotificationsBadge, {}) })] }), _jsx("button", { onClick: toggleTheme, className: "rounded-lg p-2 transition-colors", style: iconButtonStyle(), onMouseEnter: onIconHover, onMouseLeave: onIconLeave, "aria-label": theme === 'dark' ? 'Activar modo claro' : 'Activar modo oscuro', children: _jsx(NavIcon, { name: theme === 'dark' ? 'sun' : 'moon', className: "h-5 w-5" }) }), _jsx(UserMenu, {})] }));
}
//# sourceMappingURL=Header.js.map